module.exports = __webpack_public_path__ + "NanumSquareL.da1e0ddddc753bc18816.eot";


//////////////////
// WEBPACK FOOTER
// /Users/gygo/zzal/src_brand_web/src/assets/font/NanumSquareL.eot
// module id = ../../../../../src/assets/font/NanumSquareL.eot
// module chunks = styles